const Query = props => {
  const { jobsV2 } = props || {};
  const { sqlQuery } = jobsV2 || {};

  return <div>{sqlQuery}</div>;
};

export default Query;
